<template>
<div id="sheet-save-modal">
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :footer="false">
    <div v-if="error == null">
      <alert type="info">
        <progress-bar
          striped
          :value="100"
          label
          label-text="Enregistrement en cours..."
          active />
      </alert>
    </div>
    <div v-else>
      <alert type="danger">
        <p>
          <strong>
            Attention ! Une erreur s'est produite pendant la sauvegarde :
          </strong>
        </p>
        <p v-html="error" class="text-justify"></p>
        <btn @click="hide" type="default">Retour</btn>
      </alert>
    </div>
  </modal>
</div>
</template>
<script>
import impl from '@/sui/components/sheet/add/impl/save'

export default {
  name: 'sheet-save-modal',
  props: {
    value: {
      type: Boolean,
      required: true
    },

    surveillance: {
      type: Object,
      required: true
    },

    sheet: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {
      show: this.value,
      saving: this.value,
      error: null,
      reload: false
    }
  },

  methods: {
    isValid: function ({ sheet, errors }) {
      if (impl.isValid(sheet)) {
        this.showError(
          `Champs requis : l'identifiant et le code du service sont obligatoires et
doivent être renseignés.`
        )
        return false
      }

      if (errors.length > 0) {
        this.showError(errors.join('\n'))
        return false
      }

      return true
    },

    save: function () {
      if (this.saving) {
        return
      }
      this.reload = false
      this.error = null

      const r = impl.save(this.sheet, this.surveillance)
      if (r.error != null) {
        this.showError(r.error)
        return
      }

      const vm = this
      this.$store.dispatch(r.event, r.req).then(
        (response) => {
          if (response.data.id != null) {
            vm.saved(r.req.t, r.newSheet, response.data.id)
          } else {
            vm.saveError(response.data.err)
          }
        }
      ).catch(
        (e) => {
          vm.showNetworkError()
        }
      )
    },

    afterSaveRoute: function (type, newSheet, sid) {
      if (type === 'denominators' || type === 'toolsUsage') {
        return null
      }

      if (!newSheet) {
        return null
      }

      const { year, id } = this.surveillance
      return `/establishments/${year}/${id}/module/${type}/sheets/${sid}/edit`
    },

    saved: function (type, newSheet, sid) {
      this.saving = false
      this.show = false
      this.$emit('saved', this.afterSaveRoute(type, newSheet, sid))
    },

    saveError: function (error) {
      const code = error.match((/\[(.*?)\]/))[1]
      switch (code) {
        case 'BadSheetVersion':
          this.showError(`Conflit de saisie : cette fiche a été modifiée puis
enregistrée par un autre membre de la surveillance. Rechargez la en cliquant
sur le bouton «Retour», puis saisissez à nouveau vos modifications avant de
sauvegarder.`)
          this.reload = true
          break
        case 'EmptySheetFields':
          this.showError(`Fiche vide : veuillez renseigner au moins un champ
avant de l'enregistrer.`)
          break
        case 'ClosedSurveillance':
          this.showError(`Surveillance close : il n'est plus possible de 
modifier ou de supprimer cette fiche.`)
          break
        case 'AuthorizeSheet':
          this.showError(`Action non autorisée : vous n'avez pas
l'autorisation d'enregistrer cette fiche dans la surveillance.`)
          break
        default:
          this.showNetworkError()
      }
    },

    showNetworkError: function () {
      this.showError(`Erreur de connectivité :  vérifiez votre connexion 
      internet avant de réessaier. Si le problème persiste, veuillez contacter
l'administrateur du site.`)
    },

    showError: function (e) {
      this.error = e
      this.saving = false
    },

    hide: function () {
      this.$emit('close', this.reload)
    }
  },

  watch: {
    value: function () {
      this.show = this.value
      if (this.show) {
        this.save()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.alert {
    margin-bottom: 0rem;

    h4 {
        margin-top: 1rem;
    }

    .btn {
        margin-top: 2rem;
    }

}
</style>
